import { Zap } from "lucide-react";

const PLAN_COLORS = {
  trial: { bg: "rgba(100,116,139,0.15)", text: "#64748b", border: "rgba(100,116,139,0.3)" },
  starter: { bg: "rgba(59,130,246,0.12)", text: "#2563eb", border: "rgba(59,130,246,0.25)" },
  growth: { bg: "rgba(5,150,105,0.12)", text: "#059669", border: "rgba(5,150,105,0.25)" },
  enterprise: { bg: "rgba(139,92,246,0.12)", text: "#7c3aed", border: "rgba(139,92,246,0.25)" },
};

export default function TenantUsageBar({ usage, isDark }) {
  if (!usage) return null;
  const { plan, screens_used, screens_limit, screens_pct } = usage;
  const barColor = screens_pct >= 90 ? "#dc2626" : screens_pct >= 70 ? "#f97316" : "#059669";
  const planStyle = PLAN_COLORS[plan] || PLAN_COLORS.trial;
  const textColor = isDark ? "rgba(255,255,255,0.6)" : "#64748b";
  const trackColor = isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)";

  return (
    <div
      data-testid="tenant-usage-bar"
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "5px 10px",
        borderRadius: "8px",
        background: isDark ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.03)",
        border: isDark ? "1px solid rgba(255,255,255,0.08)" : "1px solid rgba(0,0,0,0.07)",
        minWidth: 0,
      }}
    >
      <Zap size={12} style={{ color: barColor, flexShrink: 0 }} />
      <div style={{ display: "flex", flexDirection: "column", gap: "3px", minWidth: 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "6px", whiteSpace: "nowrap" }}>
          <span style={{ fontSize: "11px", color: textColor, lineHeight: 1 }}>
            {screens_used.toLocaleString()} / {screens_limit.toLocaleString()} screens
          </span>
          <span
            style={{
              fontSize: "10px",
              fontWeight: 600,
              padding: "1px 6px",
              borderRadius: "999px",
              background: planStyle.bg,
              color: planStyle.text,
              border: `1px solid ${planStyle.border}`,
              lineHeight: 1.4,
              textTransform: "capitalize",
            }}
          >
            {plan}
          </span>
        </div>
        <div style={{ height: "4px", borderRadius: "999px", background: trackColor, overflow: "hidden", width: "120px" }}>
          <div
            style={{
              height: "100%",
              width: `${Math.min(screens_pct, 100)}%`,
              background: barColor,
              borderRadius: "999px",
              transition: "width 0.4s ease",
            }}
          />
        </div>
      </div>
    </div>
  );
}
